import { render } from "./Switcher.vue?vue&type=template&id=06aca578"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/Switcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06aca578"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06aca578', __exports__)) {
    api.reload('06aca578', __exports__)
  }
  
  module.hot.accept("./Switcher.vue?vue&type=template&id=06aca578", () => {
    api.rerender('06aca578', render)
  })

}


export default __exports__